import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 2c.793 0 1.52.42 1.919 1.097l.08.148 7.797 15.883a1.993 1.993 0 0 1-1.619 2.865l-.17.007H3.994a1.993 1.993 0 0 1-1.859-2.715l.07-.157L10 3.245A2.227 2.227 0 0 1 12 2zm0 1.481a.746.746 0 0 0-.616.326l-.053.091-7.797 15.884a.511.511 0 0 0 .372.729l.087.007h16.014a.511.511 0 0 0 .495-.638l-.036-.099-7.797-15.883A.746.746 0 0 0 12 3.481zm0 13.334a1.05 1.05 0 1 1 0 2.098 1.05 1.05 0 0 1 0-2.098zm0-8.642a.74.74 0 0 1 .734.64l.007.1v6.173a.74.74 0 0 1-1.475.1l-.007-.1V8.913c0-.409.332-.74.741-.74z' />
  </svg>
);
